
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/songcatcher",
      function () {
        return require("private-next-pages/features/songcatcher.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/songcatcher"])
      });
    }
  